import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/club-management";

export const List  = async (values) => {
  return await axiosInstance(options).get(`${path}/list${objToURL(values)}`);
}

export const Details  = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}`);
}

export const getBillingSnapshots = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}/billing-snapshots`);
}

export const getBillingLogs = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}/billing-logs`);
};

export const getAgreement = async (id) => await axiosInstance(options).get(`${path}/${id}/agreement`);
